export async function checkAuth(email, password) {
  // await axios
  //   .post("/login", {
  //     email: input.user_email,
  //     password: input.user_password,
  //   })
  if (
    (email === "tanjimanim007@gmail.com" && password === "12345678") ||
    (email === "testuser5678@gmail.com" && password === "123345678")
  ) {
    return {
      data: {
        token: "test123",
      },
    };
  } else {
    const error = new Error();
    error.response = {
      data: {
        error: "incorrect password or email",
      },
    };
    throw error;
  }
}
